export default __webpack_public_path__ + "static/media/formulario.fa85b487.svg";